import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../../services/shared/api-rest.service';

@Injectable({
  providedIn: 'root'
})
export class DataSelectService {
  constructor(private http: HttpClient, private _apiRestService: ApiRestService) { }

  getList(opt) {
    let json;
    switch (opt) {
      case 'banco':
        json = 'info.banco';
        break;

      case 'pais':
        json = 'info.countries';
        break;

      case 'divisiones':
        json = 'info.divisiones';
        break;

      case 'unidades':
        json = 'info.unidades';
        break;

      case 'mecaCompra':
        json = 'info.mecaCompra';
        break;

      case 'moneda':
        json = 'info.monedas';
        break;

      case 'tipoDoc':
        json = 'info.tipoDoc';
        break;

      case 'tipoDocNota':
        json = 'info.tipoDocNota';
        break;

      case 'revUni':
        json = 'info.revisionUni';
        break;

      case 'regCom':
        json = 'info.regiones-comunas';
        break;

      case 'docReq':
        json = 'info.docReq';
        break;

      case 'airports':
        json = 'airports';
        break;

      case 'tipoContrata':
        json = 'info.tipoContratacion';
        break;

      case 'tipoContrato':
        json = 'info.tipoContrato';
        break;

      case 'userCargo':
        json = 'info.userCargo';
        break;

      case 'tipoCompra':
        json = 'info.tipoCompra';
        break;

      case 'tipoResol':
        json = 'info.tipoResolucion';
        break;

      case 'tipoCambio':
        json = 'info.tipoCambio';
        break;

      case 'dptoc':
        json = 'info.deptoc';
        break;

      case 'divisionesc':
        json = 'info.divisionesc';
        break;

      case 'divisionesDptoc':
        json = 'info.divisiones.deptoc';
        break;

      case 'dividept':
        json = 'info.dividept';
        break;
      case 'codeDividept':
        json = 'info.codeDividept';
        break;
        case 'solpagDocs':
          json='info.solpagDocumentos'
    }
    return this.http.get(`${this._apiRestService.APIURL.serv3}/{"json":"${json}"}`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
}
